<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/userManagement/userAccessMenu/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
            <template v-if="getRoleId === '4' || getRoleId === '1'">
              <!-- <a @click="showModal('salesRelationModal')" class="btn-secondary ml-10"><i class="fas fa-plus-square mr-5"></i>Sales Relation</a> -->
            </template>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(is_staff)="data">
<!--          <template slot="is_staff" slot-scope="data">-->
            <b-badge v-if="data.item.is_staff == 1" variant="success">Yes</b-badge>
            <b-badge v-else variant="danger">No</b-badge>
          </template>
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <b-button v-if="getRoleId != '33'" size="sm" @click="editData('/userManagement/user/edit?id=' + data.item.id)" class="btn-table warning mr-5" disabled>
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" @click="deleteData(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'userAccessMenu',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'user_role',
          formatter: (value, key, item) => {
            return (item.user_role ? item.user_role.name : '-').replace(/_/g, ' ').toUpperCase()
          },
          label: 'Role',
          sortable: false
        },
        {
          key: 'access_menu',
          label: 'Access Menu',
          formatter: (value, key, item) => {
            return item.access_menu ? '(' + item.access_menu.id + ') ' + item.access_menu.name : ''
          },
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      getSalesId: Auth.Session.get().paradigm_id,
      getRoleId: Auth.Session.get().paradigm_role,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editData (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('vendor/v1/user_access_menu/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/sales/' + value
    },
    fetchData() {
      axios.get('vendor/v1/user_access_menu?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    // this.getSalesId = Auth.Session.get().paradigm_id
    // console.log(this.getSalesId)
    this.fetchData()
  }
}
</script>

<style>
</style>
